/**
 * Academy Realtime Service
 *
 * Subscribes to Academy realtime events through the Angular WebSocket wrapper.
 */

import RealtimeEventService from '../../../components/core/realtime/RealtimeEventService';

const EVENTS = Object.freeze({
  SkillFinished: 'skill_finished',
});

export class AcademyRealtimeService extends RealtimeEventService {
  static EVENTS = EVENTS;

  constructor(webSocketClient, logger = console) {
    super(webSocketClient, EVENTS, 'AcademyRealtimeService', logger);
  }
}

export const academyRealtimeEvents = EVENTS;

export default AcademyRealtimeService;
